import { ReactElement, useMemo } from 'react'
import { Stack, StackProps, TableCell, TableCellProps, Typography } from '@mui/material'

type MultiElementCellProps<T> = {
  list: T[],
  maxVisible?: number,
  notFound: ReactElement,
  item: (record: T, index: number) => ReactElement
  stackProps?: StackProps
} & TableCellProps
export const MultiElementCell = <T,>({
  list,
  maxVisible,
  notFound,
  item,
  stackProps,
  ...others
}: MultiElementCellProps<T>) => {
  const hiddenCount = useMemo(
    () => maxVisible === undefined ? -1 : (list.length - maxVisible),
    [list, maxVisible]
  )
  return (
    <TableCell {...others}>
      {list.length === 0 ? notFound : (
        <Stack flex={1} direction="row" spacing={0.5} {...stackProps}>
          {list.slice(0, maxVisible).map(item)}
          {hiddenCount > 0 && <Typography>+{hiddenCount}件</Typography>}
        </Stack>
      )}
    </TableCell>
  )
}
